import React, { Fragment, useState, useEffect } from "react";
import {
  ViedocButtonElement,
  ViedocCheckboxElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
  ViedocTextareaElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import * as templateActions from "../../../../store/actions/templateActions";
import AddLocationLevelSetting from "./AddLocationLevelSetting";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import APP_CONST from "../../../shared/constants";
import Loader from "../../shared/Loader/Loader";

const AddStructureElementPopUp = ({ setIsNewStructureElementVisible }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    datingConventionList,
    zoneData,
    artifactFail,
    isEditLoading,
    tmfStructureData,
  } = useSelector((store) => store.template);

  const newValue = {
    value: APP_CONST.TEXT_NEW,
    label: t("ADMIN.TEXT_NEW"),
    isDeleted: false,
  };

  const datingConventionFinalList = [
    { id: APP_CONST.SELECT_DATING, name: APP_CONST.SELECT_DATING },
    ...datingConventionList,
  ];

  const sectionsItems = _.flatten(_.pluck(zoneData, "sections"));
  const zoneDropdownValues = [
    ...zoneData.map((zoneItem) => ({
      value: zoneItem.origid + " " + zoneItem.name,
      label: zoneItem.origid + " " + zoneItem.name,
      isDeleted: zoneItem.isdeleted,
    })),
  ];
  const zoneDropdown = [
    {
      value: APP_CONST.SELECT_ZONE,
      label: t("TMF.PLACEHOLDER_SELECTZONE"),
      isDeleted: false,
    },
    ...zoneDropdownValues,
    newValue,
  ];

  let zoneId = "";
  let sectionId = "";
  const [showToaster, setShowToaster] = useState(false);
  const [showWarnings, setShowWarnings] = useState(false);
  const [selectedZone, setSelectedZone] = useState(APP_CONST.SELECT_ZONE);

  zoneId =
    selectedZone === APP_CONST.SELECT_ZONE
      ? ""
      : selectedZone?.split(" ")[0] || "";

  const sectionDropdownValues = [
    ...sectionsItems
      .map((sectionItem) => ({
        value: sectionItem.origid + " " + sectionItem.name,
        label: sectionItem.origid + " " + sectionItem.name,
        zoneid: sectionItem.origid.split(".")[0],
        isDeleted: sectionItem.isdeleted,
      }))
      .filter((section) => section.zoneid === zoneId),
  ];

  const sectionDropdown = [
    {
      value: APP_CONST.SELECT_SECTION,
      label: t("TMF.PLACEHOLDER_SELECTSECTION"),
      isDeleted: false,
    },
    ...sectionDropdownValues,
    newValue,
  ];

  const [selectedSectionName, setSelectedSectionName] = useState(
    APP_CONST.SELECT_SECTION
  );
  sectionId =
    selectedSectionName === APP_CONST.SELECT_SECTION
      ? ""
      : selectedSectionName?.split(" ")[0] || "";

  const [initialLoad, setInitialLoad] = useState(true);
  const [isTouched, setIsTouched] = useState(false);
  const [artifactName, setArtifactName] = useState();
  const [definition, setDefinition] = useState(null);
  const [uniqueId, setUniqueId] = useState();
  const [firstSubArtifact, setFirstSubArtifact] = useState("");
  const [addSubartifact, setAddSubartifact] = useState([]);
  const [isSponsor, setIsSponsor] = useState(false);
  const [isInvestigator, setIsInvestigator] = useState(false);
  const [newZoneName, setNewZoneName] = useState();
  const [newSectionName, setNewSectionName] = useState();

  const [selectedDatingConvention, setSelectedDatingConvention] = useState(
    APP_CONST.SELECT_DATING
  );
  const [newDatingConvention, setNewDatingConvention] = useState();

  const [detailsValue, setDetailsValue] = useState();
  const [blindedData, setBlindedData] = useState();
  const [privacyData, setPrivacyData] = useState();

  const [fileFormats, setFileFormats] = useState();

  const [addSupportedFilesTypes, setAddSupportedFilesTypes] = useState([]);
  let subArtifactPayload = [firstSubArtifact, ...addSubartifact];

  const [trialMilestone, setTrialMilestone] = useState("");
  const [countryMilestone, setCountryMilestone] = useState("");
  const [siteMilestone, setSiteMilestone] = useState("");

  const [trialDocument, setTrialDocument] = useState();
  const [countryDocument, setCountryDocument] = useState();
  const [siteDocument, setSiteDocument] = useState();

  const [trialRolesAndAccessPayload, setTrialRolesAndAccessPayload] = useState(
    UtilsHelper.createRolesAndAccessPayload("trial",trialDocument === APP_CONST.TEXT_NOT_PERMITTED ?"NO ACCESS" : "")
  );
  const [countryRolesAndAccessPayload, setCountryRolesAndAccessPayload] =
    useState(UtilsHelper.createRolesAndAccessPayload("country",countryDocument === APP_CONST.TEXT_NOT_PERMITTED ?"NO ACCESS" : ""));
  const [siteRolesAndAccessPayload, setSiteRolesAndAccessPayload] = useState(
    UtilsHelper.createRolesAndAccessPayload("site", siteDocument === APP_CONST.TEXT_NOT_PERMITTED ?"NO ACCESS" : "")
  );

  const [clinicalUserChecked, setClinicalUserChecked] = useState(false);
  const [viedocMeUserChecked, setViedocMeUserChecked] = useState(false);

  useEffect(() => {
    !_.isEmpty(artifactFail) && setShowToaster(true);
    if (_.isEmpty(artifactFail) && !isEditLoading && !initialLoad) {
      setIsNewStructureElementVisible(false);
      setInitialLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artifactFail, isEditLoading]);

  useEffect(() => {
    if (
      selectedSectionName !== APP_CONST.SELECT_SECTION &&
      !_.isEmpty(artifactName) &&
      !_.isEmpty(definition) &&
      !_.isEmpty(detailsValue) &&
      !_.isEmpty(blindedData) &&
      !_.isEmpty(privacyData) &&
      selectedDatingConvention !== APP_CONST.SELECT_DATING &&
      !_.isEmpty(trialDocument) &&
      !_.isEmpty(countryDocument) &&
      !_.isEmpty(siteDocument) &&
      !_.isEmpty(fileFormats)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    }
  }, [
    artifactName,
    blindedData,
    countryDocument,
    definition,
    detailsValue,
    fileFormats,
    privacyData,
    selectedDatingConvention,
    selectedSectionName,
    siteDocument,
    trialDocument,
  ]);

  useEffect(() => {
    if (siteDocument !== "Not permitted" && !_.isEmpty(siteMilestone)) {
      setShowToaster(false);
      setShowWarnings(false);
    } else if (
      trialDocument !== "Not permitted" &&
      !_.isEmpty(trialMilestone)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    } else if (
      countryDocument !== "Not permitted" &&
      !_.isEmpty(countryMilestone)
    ) {
      setShowToaster(false);
      setShowWarnings(false);
    }
  }, [
    countryDocument,
    countryMilestone,
    siteDocument,
    siteMilestone,
    trialDocument,
    trialMilestone,
  ]);

  const sendRolesAndAccessData = (data, type) => {
    switch (type) {
      case "trial":
        setTrialRolesAndAccessPayload(data);
        break;
      case "country":
        setCountryRolesAndAccessPayload(data);
        break;
      case "site":
        setSiteRolesAndAccessPayload(data);
        break;
      default:
        break;
    }
  };
  const sendDocument = (data, type) => {
    switch (type) {
      case "trial":
        setTrialDocument(data);
        break;
      case "country":
        setCountryDocument(data);
        break;
      case "site":
        setSiteDocument(data);
        break;
      default:
        break;
    }
  };

  const sendMilestone = (data, type) => {
    switch (type) {
      case "trial":
        setTrialMilestone(data);
        break;
      case "country":
        setCountryMilestone(data);
        break;
      case "site":
        setSiteMilestone(data);
        break;
      default:
        break;
    }
  };

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const classificationArray = [
    {
      id: 1,
      label1: t("TMF.TEXT_ZONENO"),
      value1: selectedZone !== APP_CONST.TEXT_NEW ? zoneId : "",
      class: "disabled_input",
      isFieldDisabled: true,
      isSelectDisabled: false,
      label2: t("DETAILPAGE.LABEL_ZONENAME"),
      isRequired: true,
      options: zoneDropdown,
      selected: selectedZone,
      placeholder: "- - -",
    },
    {
      id: 2,
      label1: t("TMF.TEXT_SECTIONNO"),
      value1: selectedSectionName !== APP_CONST.TEXT_NEW ? sectionId : "",
      class: "disabled_input",
      isFieldDisabled: true,
      isSelectDisabled:
        selectedZone === APP_CONST.SELECT_ZONE ||
        (selectedZone === APP_CONST.TEXT_NEW && _.isEmpty(newZoneName)),
      label2: t("TMF.TEXT_SECTIONNAME"),
      isRequired: true,
      options: sectionDropdown,
      selected: selectedSectionName,
      placeholder: "- - -",
    },
    {
      id: 3,
      label1: t("ADMIN.ADMINTAB_ARTIFACT"),
      value1: "",
      class: "disabled_input",
      isFieldDisabled: true,
      label2: t("ADMIN.ADMINTAB_ARTIFACTNAME"),
      isRequired: true,
      options: [],
      selected: [],
    },
  ];

  const tmfSideArray = [
    { id: 1, checkedValue: isSponsor, label: t("TMF.FORMLABEL_SPONSOR") },
    {
      id: 2,
      checkedValue: isInvestigator,
      label: t("ADMIN.FORMLABEL_INVESTIGATOR"),
    },
  ];

  const sharingSectionArray = [
    {
      id: 1,
      checkLabel: t("TMF.TEXT_VIEDOCCLINICALUSERS"),
      name: "clinicalUser",
      checked: clinicalUserChecked,
    },
    {
      id: 2,
      checkLabel: t("ADMIN.ADMINTAB_VIEDOCMEUSERS"),
      name: "viedocMeUser",
      checked: viedocMeUserChecked,
    },
  ];

  const getDetailsSectionRequiredValues = (type) => {
    if (
      detailsValue !== "*" &&
      detailsValue !== "Files" &&
      type === "Details" &&
      showWarnings
    ) {
      return true;
    }
    if (
      blindedData !== "ACCEPTED" &&
      blindedData !== "NOT ACCEPTED" &&
      type === "Blinded data" &&
      showWarnings
    ) {
      return true;
    }
    if (
      privacyData !== "ACCEPTED" &&
      privacyData !== "NOT ACCEPTED" &&
      type === "Privacy data" &&
      showWarnings
    ) {
      return true;
    }
    return false;
  };

  const detailsSectionArray = [
    {
      id: 1,
      mainLabel: t("ADMIN.ADMINTAB_DETAILS"),
      radioLabel1: t("ARCHIVE.FORMLABEL_STANDARD"),
      radioLabel2: t("ARCHIVE.FORMLABEL_ONLYFILENAMEEXTENSIONS"),
      type: "Details",
      location1: "Standard",
      location2: "Only filename extensions",
      checked1: detailsValue === "*",
      checked2: detailsValue === "Files",
    },
    {
      id: 2,
      mainLabel: t("ADMIN.ADMINTAB_BLINDEDDATA"),
      radioLabel1: t("ADMIN.TEXT_ACCEPTED"),
      radioLabel2: t("ADMIN.TEXT_NOTACCEPTED"),
      location1: "Accepted",
      location2: "Not accepted",
      type: "Blinded data",
      checked1: blindedData === "ACCEPTED",
      checked2: blindedData === "NOT ACCEPTED",
    },
    {
      id: 3,
      mainLabel: t("ADMIN.ADMINTAB_PRIVACYDATA"),
      radioLabel1: t("ADMIN.TEXT_ACCEPTED"),
      radioLabel2: t("ADMIN.TEXT_NOTACCEPTED"),
      location1: "Accepted",
      location2: "Not accepted",
      type: "Privacy data",
      checked1: privacyData === "ACCEPTED",
      checked2: privacyData === "NOT ACCEPTED",
    },
  ];

  const onHide = () => {
    dispatch(templateActions.clearArtifactError());
    setIsNewStructureElementVisible(false);
  };

  function sharingCheckboxHandler(from, e) {
    setIsTouched(true);
    switch (from) {
      case "clinicalUser":
        setClinicalUserChecked(e.target.checked);
        return;
      case "viedocMeUser":
        setViedocMeUserChecked(e.target.checked);
        return;
      default:
        break;
    }
  }

  const renderSharingSection = () => {
    return (
      <section className="view-artifact-block ff-vmg edit-structure-popup">
        <article className="sem-pri-color">
          {t("TMF.TEXT_DOCFILESHARING")}
        </article>
        <aside className="d-flex flex-dir-col edit-structure-detail">
          <div className="pt-10">
            <div className="d-flex pad-10 align-center">
              <div className="w-25 text-right pr-10 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_ENABLEFOR")}
              </div>
              {sharingSectionArray.map((sharing) => (
                <div className="d-flex gap-20 f14" key={sharing.id}>
                  <ViedocCheckboxElement
                    class={`tmfside-checkbox ${
                      sharing.id === 2 ? "pl-10" : ""
                    }`}
                    size="small"
                    checked={sharing.checked}
                    onChange={(e) => {
                      sharingCheckboxHandler(sharing.name, e);
                    }}
                  >
                    {sharing.checkLabel}
                  </ViedocCheckboxElement>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const checkEmptySubArtifactsAndFileFormats = (first, second, skip) => {
    if (_.isEmpty(first) && !skip) {
      return true;
    }

    for (let i = 0; i < second.length; i++) {
      if (_.isEmpty(second[i])) {
        return true;
      }
    }
    return false;
  };

  const validateRequiredFields = (requestPayload) => {
    if (
      selectedSectionName === APP_CONST.SELECT_SECTION ||
      _.isEmpty(artifactName) ||
      _.isEmpty(definition) ||
      _.isEmpty(detailsValue) ||
      _.isEmpty(blindedData) ||
      _.isEmpty(privacyData) ||
      selectedDatingConvention === APP_CONST.SELECT_DATING ||
      _.isEmpty(trialDocument) ||
      _.isEmpty(countryDocument) ||
      _.isEmpty(siteDocument)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableAtSite !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.siteLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableInTrial !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.trialLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      requestPayload.artifact.applicableInCountry !== "Not permitted" &&
      _.isEmpty(requestPayload.artifact.countryLevelMilestone)
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else if (
      checkEmptySubArtifactsAndFileFormats(
        firstSubArtifact,
        addSubartifact,
        true
      ) ||
      (checkEmptySubArtifactsAndFileFormats(
        fileFormats,
        addSupportedFilesTypes
      ) &&
        detailsValue !== "*")
    ) {
      setShowToaster(true);
      setShowWarnings(true);
    } else {
      setShowToaster(false);
      setShowWarnings(false);
      dispatch(templateActions.addNewArtifact(requestPayload));
      setInitialLoad(false);
      setIsTouched(false);
    }
  };

  const saveChangesHandler = () => {
    let ModifiedDateValue = zoneData.filter((data) => data.origid === zoneId);
    let trailUserRoleAccess = trialDocument !== APP_CONST.TEXT_NOT_PERMITTED ? trialRolesAndAccessPayload : [];
    let countryUserRoleAccess = countryDocument !== APP_CONST.TEXT_NOT_PERMITTED ? countryRolesAndAccessPayload : [];
    let siteUserRoleAccess = siteDocument !== APP_CONST.TEXT_NOT_PERMITTED ? siteRolesAndAccessPayload : [];
    let modifiedDate = "";
    if (ModifiedDateValue && !_.isEmpty(ModifiedDateValue)) {
      modifiedDate = ModifiedDateValue[0].recentModifiedOn;
    }
    let requestPayload = {
      lastmodifiedon: modifiedDate || tmfStructureData?.lastmodifiedon,
      zone: {
        id: selectedZone !== APP_CONST.TEXT_NEW ? zoneId : null,
        name: selectedZone === APP_CONST.TEXT_NEW ? newZoneName : null,
      },
      section: {
        id: selectedSectionName !== APP_CONST.TEXT_NEW ? sectionId : null,
        name:
          selectedSectionName === APP_CONST.TEXT_NEW ? newSectionName : null,
      },
      artifact: {
        name: artifactName,
        definition: definition,
        subArtifacts: subArtifactPayload.map((subArts) => {
          return {
            name: subArts,
            islinkshared: false,
          };
        }),
        isartifactlinkshared: false,
        uniqueIdNumber: uniqueId,
        applicableInTrial: trialDocument,
        applicableInCountry: countryDocument,
        applicableAtSite: siteDocument,
        sponsorDocument: isSponsor,
        investigatorDocument: isInvestigator,
        artifactUserAccess: [
          ...trailUserRoleAccess,
          ...countryUserRoleAccess,
          ...siteUserRoleAccess,
        ],
        trialLevelMilestone: trialMilestone || "",
        countryLevelMilestone: countryMilestone || "",
        siteLevelMilestone: siteMilestone || "",
        fileFormats:
          detailsValue === "*"
            ? [detailsValue]
            : [fileFormats, ...addSupportedFilesTypes],
        acceptBlindedData: blindedData === "ACCEPTED",
        acceptPrivacyData: privacyData === "ACCEPTED",
        datingConvention:
          selectedDatingConvention === APP_CONST.TEXT_NEW
            ? newDatingConvention
            : selectedDatingConvention,
      },
      sharing: {
        artifactid: "",
        clinicaluser: {
          enable: clinicalUserChecked || false,
        },
        subjectuser: {
          enable: viedocMeUserChecked || false,
        },
      },
    };
    validateRequiredFields(requestPayload);
  };

  const renderArtifactNameField = () => {
    return (
      <viedoc-textfield
        class={
          artifactFail.includes("existing artifact")
            ? "disabled_input w-365 required-warning"
            : "disabled_input w-365"
        }
        size="small"
        variant="outline"
        required={
          showWarnings &&
          _.isEmpty(artifactName) &&
          !(
            selectedSectionName === APP_CONST.SELECT_SECTION ||
            (selectedSectionName === APP_CONST.TEXT_NEW &&
              _.isEmpty(newSectionName))
          )
            ? true
            : null
        }
      >
        <input
          type="text"
          value={artifactName}
          onChange={(e) => setArtifactName(e.target.value.trimStart())}
          disabled={
            selectedSectionName === APP_CONST.SELECT_SECTION ||
            (selectedSectionName === APP_CONST.TEXT_NEW &&
              _.isEmpty(newSectionName))
          }
        />
      </viedoc-textfield>
    );
  };

  const newNameHandler = (event, type) => {
    switch (type) {
      case "zone":
        setNewZoneName(event.target.value.trimStart());
        break;
      case "section":
        setNewSectionName(event.target.value.trimStart());
        break;
      case "dating":
        setNewDatingConvention(event.target.value);
        break;
      default:
        return;
    }
    setIsTouched(true);
  };

  const renderNewField = (type) => {
    let isWarning = false;

    if (type === "zone" && _.isEmpty(newZoneName)) {
      isWarning = true;
    } else if (type === "section" && _.isEmpty(newSectionName)) {
      isWarning = true;
    } else if (type === "dating" && _.isEmpty(newDatingConvention)) {
      isWarning = true;
    }
    return (
      <div className={isWarning && showWarnings ? "mt-10 warning" : "mt-10"}>
        <viedoc-textfield class="disabled_input" size="small" variant="outline">
          <input
            type="text"
            value={
              type === "zone"
                ? newZoneName
                : type === "dating"
                ? newDatingConvention
                : newSectionName
            }
            onChange={(e) => newNameHandler(e, type)}
          />
        </viedoc-textfield>
      </div>
    );
  };

  const zoneSectionSelectHandler = (event, info) => {
    switch (info.label2) {
      case t("DETAILPAGE.LABEL_ZONENAME"):
        setSelectedZone(event.target.value);
        setSelectedSectionName(APP_CONST.SELECT_SECTION);
        break;
      case t("TMF.TEXT_SECTIONNAME"):
        setSelectedSectionName(event.target.value);
        break;
      default:
        return;
    }
    setIsTouched(true);
  };

  function onChangeFieldHandler(event, location, index) {
    switch (location) {
      case t("ADMIN.ADMINTAB_ARTIFACTNAME"):
        setArtifactName(event.target.value.trimStart());
        break;

      case t("ADMIN.ADMINTAB_SUBARTIFACTS"):
        setFirstSubArtifact(event.target.value.trimStart());
        break;

      default:
        const inputValue = [...addSubartifact];
        inputValue[index] = event.target.value.trimStart();
        setAddSubartifact(inputValue);
    }
    setIsTouched(true);
  }

  const addSubArtifactHandler = () => {
    const newSubArtifactsList = [...addSubartifact, []];
    setAddSubartifact(newSubArtifactsList);
    setIsTouched(true);
  };

  const removeSubartifactHandler = (index) => {
    const deleteValue = [...addSubartifact];
    deleteValue.splice(index, 1);
    setAddSubartifact(deleteValue);
    setIsTouched(true);
  };

  const getIsRequired = (fieldLabel, fieldValue) => {
    if (
      showWarnings &&
      _.isEmpty(fieldValue) &&
      fieldLabel === t("ADMIN.ADMINTAB_ARTIFACTNAME")
    ) {
      return true;
    } else if (showWarnings && _.isEmpty(fieldValue) && fieldLabel === null) {
      return true;
    } else {
      return null;
    }
  };

  function renderSubArtifactsBlock(
    fieldLabel,
    fieldValue,
    isRequired,
    isRemoveIcon,
    index
  ) {
    return (
      <Fragment key={index}>
        <div className="d-flex pad-5 align-center">
          <div className="w-25 text-right pr-15 gray-60 fw-400">
            {fieldLabel}
            {isRequired ? spanFunc() : null}
          </div>
          <viedoc-textfield
            class="disabled_input w-365"
            size="small"
            variant="outline"
            required={getIsRequired(fieldLabel, fieldValue)}
          >
            <input
              type="text"
              value={fieldValue}
              onChange={(e) => onChangeFieldHandler(e, fieldLabel, index)}
            />
          </viedoc-textfield>

          <div className="icon-holder ml-10 ">
            {isRemoveIcon ? (
              <viedoc-icon
                title={t("ADMIN.TEXT_REMOVE")}
                name="remove"
                onClick={() => removeSubartifactHandler(index)}
              />
            ) : (
              <viedoc-icon title={t("ADMIN.TEXT_ADD")} name="add" onClick={() => addSubArtifactHandler()} />
            )}
          </div>
        </div>
      </Fragment>
    );
  }

  function tmfSideCheckboxHandler(location) {
    switch (location) {
      case t("TMF.FORMLABEL_SPONSOR"):
        setIsSponsor((prevState) => !prevState);
        break;
      case t("ADMIN.FORMLABEL_INVESTIGATOR"):
        setIsInvestigator((prevState) => !prevState);
        break;
      default:
        return;
    }
    setIsTouched(true);
  }

  const renderClassificationSection = () => {
    return (
      <section className="view-artifact-block ff-vmg add-struture-popup">
        <article className="sem-pri-color">
          {t("ADMIN.TEXT_CLASSIFICATIONLBL")}
        </article>
        <aside className="d-flex flex-dir-col structure-clasification">
          <div className="pt-10">
            {classificationArray.map((classification) => (
              <div key={classification.id}>
                <div className="d-flex pad-5 align-center">
                  <div className="w-25 text-right pr-15 gray-60 fw-400">
                    {classification.label1}
                  </div>
                  <viedoc-textfield
                    class={classification.class}
                    size="small"
                    variant="outline"
                  >
                    <input
                      type="text"
                      disabled={classification.isFieldDisabled}
                      value={classification.value1}
                    />
                  </viedoc-textfield>
                </div>
                <div className="d-flex pad-5 align-center">
                  <div className="w-25 text-right pr-15 gray-60 fw-400">
                    {classification.label2}
                    {classification.isRequired ? spanFunc() : null}
                  </div>
                  <>
                    {classification.label2 ===
                    t("ADMIN.ADMINTAB_ARTIFACTNAME") ? (
                      renderArtifactNameField()
                    ) : (
                      <div
                        className={
                          showWarnings &&
                          (classification.selected ===
                            APP_CONST.SELECT_SECTION ||
                            classification.selected === APP_CONST.SELECT_ZONE)
                            ? "w-450 tmfside-checkbox warning"
                            : "w-450 tmfside-checkbox"
                        }
                      >
                        <ViedocSelectElement
                          size="small"
                          value={classification.selected}
                          disabled={classification.isSelectDisabled}
                          placeholder={classification.placeholder}
                          onChange={(e) =>
                            zoneSectionSelectHandler(e, classification)
                          }
                        >
                          {classification.options.map((option) => (
                            <ViedocMenuItemElement
                              key={option.value}
                              value={option.value}
                              disabled={option.isDeleted}
                              hidden={
                                option.value === APP_CONST.SELECT_ZONE ||
                                option.value === APP_CONST.SELECT_SECTION
                              }
                            >
                              {option.label}
                            </ViedocMenuItemElement>
                          ))}
                        </ViedocSelectElement>
                        {selectedZone === APP_CONST.TEXT_NEW &&
                          classification.label2 ===
                            t("DETAILPAGE.LABEL_ZONENAME") &&
                          renderNewField("zone")}
                        {selectedSectionName === APP_CONST.TEXT_NEW &&
                          classification.label2 === t("TMF.TEXT_SECTIONNAME") &&
                          renderNewField("section")}
                      </div>
                    )}
                  </>
                </div>
              </div>
            ))}
            <div className="d-flex pt-0 pb-5 ">
              <div className="w-25 text-right pr-15 pt-20 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_DEFINITION")}
                {spanFunc()}
              </div>
              <ViedocTextareaElement
                placeholder=""
                value={definition}
                rows={3}
                onChange={(e) => {
                  setIsTouched(true);
                  setDefinition(e.target.value.trimStart());
                }}
                class={
                  showWarnings && _.isEmpty(definition)
                    ? "definition-area warning"
                    : "definition-area"
                }
              />
            </div>
            <div className="d-flex pad-5 align-center">
              <div className="w-25 text-right pr-15 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_UNIQUEID")}
              </div>
              <viedoc-textfield
                class={
                  artifactFail.includes("unique Id")
                    ? "disabled_input w-450 required-warning"
                    : "disabled_input w-450"
                }
                size="small"
                variant="outline"
              >
                <input
                  type="text"
                  value={uniqueId}
                  onChange={(e) => {
                    setIsTouched(true);
                    setUniqueId(e.target.value);
                  }}
                />
              </viedoc-textfield>
            </div>
            {renderSubArtifactsBlock(
              t("ADMIN.ADMINTAB_SUBARTIFACTS"),
              firstSubArtifact,
              false,
              false,
              null
            )}
            {addSubartifact.map((data, index) => {
              return renderSubArtifactsBlock(null, data, false, true, index);
            })}
            <div className="d-flex pad-5 align-center">
              <div className="w-25 text-right pr-7 gray-60 fw-400">
                {t("ADMIN.TEXT_TMFSIDE")}
              </div>
              {tmfSideArray.map((tmf) => (
                <ViedocCheckboxElement
                  key={tmf.id}
                  class="pl-10 tmfside-checkbox"
                  checked={tmf.checkedValue}
                  onChange={() => tmfSideCheckboxHandler(tmf.label)}
                >
                  {tmf.label}
                </ViedocCheckboxElement>
              ))}
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const detailsRadioHandler = (location, type) => {
    switch (type) {
      case "Details":
        if (location === "Standard") {
          setDetailsValue("*");
          setFileFormats("");
          setAddSupportedFilesTypes([]);
        } else {
          setDetailsValue("Files");
        }
        break;
      case "Blinded data":
        setBlindedData(location.toUpperCase());
        break;
      case "Privacy data":
        setPrivacyData(location.toUpperCase());
        break;
      default:
        break;
    }
    setIsTouched(true);
  };

  const addSupportedFileshandler = () => {
    setAddSupportedFilesTypes([...addSupportedFilesTypes, []]);
    setIsTouched(true);
  };

  const addFileTypesHandler = (event, index) => {
    const inputData = [...addSupportedFilesTypes];
    inputData[index] = event.target.value;
    setAddSupportedFilesTypes(inputData);
    setIsTouched(true);
  };

  const removeFileTypeshandler = (index) => {
    const deleteValue = [...addSupportedFilesTypes];
    deleteValue.splice(index, 1);
    setAddSupportedFilesTypes(deleteValue);
    setIsTouched(true);
  };

  const renderDetailsSection = () => {
    return (
      <section className="view-artifact-block ff-vmg add-new-structure-popup">
        <article className="sem-pri-color">
          {t("ADMIN.ADMINTAB_DETAILS")}
        </article>
        <aside className="d-flex flex-dir-col add-new-structure-details">
          <div className="pt-10">
            {detailsSectionArray.map((details) => (
              <Fragment key={details.id}>
                <div className="d-flex pad-10 align-center">
                  <div className="w-25 text-right pr-10 gray-60 fw-400">
                    {details.mainLabel}
                    {spanFunc()}
                  </div>
                  <div className="d-flex gap-20 f14">
                    <ViedocRadioElement
                      class="tmfside-checkbox"
                      checked={details.checked1}
                      required={getDetailsSectionRequiredValues(details.type)}
                      onChange={() =>
                        detailsRadioHandler(details.location1, details.type)
                      }
                    >
                      {details.radioLabel1}
                    </ViedocRadioElement>

                    <ViedocRadioElement
                      class="tmfside-checkbox"
                      checked={details.checked2}
                      required={getDetailsSectionRequiredValues(details.type)}
                      onChange={() =>
                        detailsRadioHandler(details.location2, details.type)
                      }
                    >
                      {details.radioLabel2}
                    </ViedocRadioElement>
                  </div>
                </div>
                {details.type === "Details" && detailsValue === "Files" && (
                  <div className="icon-holder ml-210 w-450 pad-5 d-flex supported-files">
                    <viedoc-textfield
                      size="small"
                      variant="outline"
                      class={
                        showWarnings && _.isEmpty(fileFormats) ? "warning" : ""
                      }
                    >
                      <input
                        type="text"
                        value={fileFormats}
                        onChange={(e) => {
                          setIsTouched(true);
                          setFileFormats(e.target.value);
                        }}
                      />
                    </viedoc-textfield>
                    <viedoc-icon
                      title={t("ADMIN.TEXT_ADD")}
                      name="add"
                      onClick={() => addSupportedFileshandler()}
                    />
                    {addSupportedFilesTypes.map((block, index) => {
                      return (
                        <div
                          className="icon-holder ml-10 w-80 d-flex supported-files"
                          key={index}
                        >
                          <viedoc-textfield
                            size="small"
                            variant="outline"
                            class={
                              showWarnings && _.isEmpty(block) ? "warning" : ""
                            }
                          >
                            <input
                              type="text"
                              value={block}
                              onChange={(e) => addFileTypesHandler(e, index)}
                            />
                          </viedoc-textfield>
                          <viedoc-icon
                            title={t("ADMIN.TEXT_REMOVE")}
                            name="remove"
                            onClick={() => removeFileTypeshandler(index)}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Fragment>
            ))}
            <div className="d-flex pad-10 align-center">
              <div className="w-25 text-right pr-10 gray-60 fw-400">
                {t("ADMIN.ADMINTAB_DATINGCONVENTION")}
                {spanFunc()}
              </div>
              <div
                className={
                  showWarnings &&
                  selectedDatingConvention === APP_CONST.SELECT_DATING
                    ? "w-450 tmfside-checkbox warning"
                    : "w-450 tmfside-checkbox"
                }
              >
                <ViedocSelectElement
                  size="small"
                  value={selectedDatingConvention}
                  onChange={(e) => {
                    setIsTouched(true);
                    setSelectedDatingConvention(e.target.value);
                  }}
                >
                  {datingConventionFinalList.map((dating) => (
                    <ViedocMenuItemElement
                      key={dating.id}
                      value={dating.name}
                      hidden={dating.name === APP_CONST.SELECT_DATING}
                    >
                      {dating.name === APP_CONST.SELECT_DATING
                        ? t("ADMIN.TEXT_SELECTDATINGCONVENTION")
                        : dating.name}
                    </ViedocMenuItemElement>
                  ))}
                </ViedocSelectElement>
                {selectedDatingConvention === APP_CONST.TEXT_NEW &&
                  renderNewField("dating")}
              </div>
            </div>
          </div>
        </aside>
      </section>
    );
  };

  const renderToaster = (message) => {
    return (
      showToaster && (
        <viedoc-toaster
          onClick={() => setShowToaster(false)}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };

  return (
    <ViedocDialogElement
      size="large"
      class="edit-artifact-popup"
      open
      preventCloseByClick
      onHide={() => onHide()}
    >
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">{t("ADMIN.BUTTON_ADDNEWARTIFACT")}</p>
        <div className="header-button">
          <ViedocButtonElement
            size="small"
            variant="neutral"
            disabled={!isTouched}
            onClick={() => saveChangesHandler()}
            title={t("ADMIN.BUTTON_SAVEBTN")}
          >
            {t("ADMIN.BUTTON_SAVEBTN")}
          </ViedocButtonElement>
        </div>
      </header>
      {isEditLoading ? (
        <Loader width={"100%"} height={"100%"} borderRadius />
      ) : (
        <Fragment>
          {renderToaster(artifactFail ? artifactFail : t("TMF.TOAST_REQUIRED"))}
          {renderClassificationSection()}
          <div className="bb-2 w-100"></div>
          <AddLocationLevelSetting
            label={`${t("ADMIN.TEXT_TRIAL")} ${t("ADMIN.TEXT_LEVELSETTINGS")}`}
            type="trial"
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            setIsTouched={setIsTouched}
            showWarnings={showWarnings}
            RadioFieldRequired = {trialDocument === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {trialDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {trialDocument === APP_CONST.TEXT_NOT_PERMITTED ? true : false}
            selectedMilestoneValue = {trialMilestone}
            selectedRolesAndAccess = {trialRolesAndAccessPayload}
          />
          <div className="bb-2 w-100"></div>
          <AddLocationLevelSetting
            label={`${t("ADMIN.TEXT_COUNTRYLBL")} ${t(
              "ADMIN.TEXT_LEVELSETTINGS"
            )}`}
            type="country"
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            setIsTouched={setIsTouched}
            showWarnings={showWarnings}
            RadioFieldRequired = {countryDocument === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {countryDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {countryDocument === APP_CONST.TEXT_NOT_PERMITTED? true : false}
            selectedMilestoneValue = {countryMilestone}
            selectedRolesAndAccess = {countryRolesAndAccessPayload}
          />
          <div className="bb-2 w-100"></div>
          <AddLocationLevelSetting
            label={`${t("ADMIN.TEXT_SITELBL")} ${t(
              "ADMIN.TEXT_LEVELSETTINGS"
            )}`}
            type="site"
            sendRolesAndAccessData={sendRolesAndAccessData}
            sendMilestone={sendMilestone}
            sendDocument={sendDocument}
            setIsTouched={setIsTouched}
            showWarnings={showWarnings}
            RadioFieldRequired = {siteDocument  === APP_CONST.TEXT_REQUIRED ? true : false}
            RadioFieldOPtional = {siteDocument === APP_CONST.TEXT_OPTIONAL ? true : false}
            RadioFieldNotPermitted = {siteDocument === APP_CONST.TEXT_NOT_PERMITTED ? true : false}
            selectedMilestoneValue = {siteMilestone}
            selectedRolesAndAccess = {siteRolesAndAccessPayload}
          />
          <div className="bb-2 w-100"></div>
          {renderDetailsSection()}
          <div className="bb-2 w-100"></div>
          {renderSharingSection()}
        </Fragment>
      )}
      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default AddStructureElementPopUp;
